import { createSelector } from 'reselect';
import { sportClubsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const sportClubsYearsSelector = createSelector([sportClubsSelector], (sportClubs) =>
  extractDatesFromNestedItems(
    [sportClubs.content],
    [
      {
        startField: 'startDate',
        endField: 'endDate',
        type: 'range',
      },
    ],
  ),
);
